import ViewPadrao from "../views/ViewPadrao";
import FormaPgtoList from "../views/FormaPgtoList";
import FormaPgtoCad from "../views/FormaPgtoCad";

export default {
  path: "forma-pagamento",
  component: ViewPadrao,
  children: [
    {
      path: "lista",
      name: "forma-pagamento-list",
      component: FormaPgtoList
    },
    {
      path: "novo",
      name: "forma-pagamento-formulario",
      component: FormaPgtoCad
    },
    {
      path: "editar/:id",
      name: "forma-pagamento-formulario-editar",
      component: FormaPgtoCad
    }
  ]
};
